import React, { useState } from "react";
import { InfoForm, InfoFormGray } from "~misc/icons";

const Info = ({ bg, text, position = "right", tooltipClass = "" }) => {
  const [hovermouse, Sethovermouse] = useState(false);
  const whenHoveringMouse = () => Sethovermouse((prev) => !prev);

  const getPositionClass = () => {
    if (position === "left") {
      return "absolute w-max max-w-[70vw] right-full mr-2 top-1/2 -translate-y-1/2";
    }
    if (position === "top-left") {
      return "absolute w-max max-w-[70vw] right-0 mr-0 bottom-5 -translate-y-1/2";
    }
    if (position === "mobile-left") {
      return "absolute w-max max-w-[70vw] right-full mr-2 top-1/2 -translate-y-1/2 lg:left-full lg:ml-2 lg:right-auto lg:mr-0";
    }
    if (position === "bottom-center") {
      return "absolute w-max max-w-[70vw] left-1/2 -translate-x-1/2 top-full mt-2";
    }

    return "absolute w-max max-w-[70vw] left-full ml-2 top-1/2 -translate-y-1/2";
  };
  const positionClass = getPositionClass();
  return (
    <div className={bg == "blue" ? "relative flex items-center gap-2 info-blue" : "relative flex items-center gap-2"}>
      <span className="cursor-pointer " onMouseEnter={whenHoveringMouse} onMouseLeave={whenHoveringMouse}>
        {bg == "blue" ? <InfoForm className={tooltipClass}/> : <InfoFormGray />}
      </span>
      {hovermouse && (
        <div className={`${positionClass} z-[99999]`}>
          <p
            className={
              (bg == "blue"
                ? "px-[10px] p-[5px] bg-[#034EA2] rounded-lg text-primario text-sm flex flex-col items-center text-white relative z-40"
                : "px-[10px] p-[5px] bg-[#E6E6E6] rounded-lg text-primario text-sm flex flex-col items-center relative z-40") +
              " break-words whitespace-pre-line max-w-[90vw]"
            }
          >
            {text ? text : "Não Possui Dupla Categoria"}
          </p>
        </div>
      )}
    </div>
  );
};

export default Info;
